<template>
  <div class="fs-textinput" :style="wrapperStyle" v-show="show" @click.self="clickBG">
    <div class="fs-form" @click.stop="">
      <!-- 文字框上面的訊息 -->
      <div class="fs-label" v-html="title1"></div>
      <textarea class="fs-textarea" v-if="show" v-model="tmpInput1" :placeholder="placeholder1"></textarea>
      <div class="fs-label" v-html="title2"></div>
      <textarea class="fs-textarea" v-if="show" v-model="tmpInput2" :placeholder="placeholder2"></textarea>
      <div class="fs-form-control">
        <button class="fs-btn fs-btn-submit" @click="submit()">
          送出
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    width: {
      type: Number,
      required: true
    },
    height: {
      type: Number,
      required: true
    },
    top: {
      type: Number,
      required: true
    },
    left: {
      type: Number,
      required: true
    },
    title1: {
      type: String,
      default: ''
    },
    title2: {
      type: String,
      default: ''
    },
    placeholder1: {
      type: String,
      default: ''
    },
    placeholder2: {
      type: String,
      default: ''
    },
    defaultValue1: {
      type: String,
      default: ''
    },
    defaultValue2: {
      type: String,
      default: ''
    },
    background: {
      type: String,
      default: '#222A'
    },
    // show / hide
    show: {
      type: Boolean,
      required: true
    },
    cancellable: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    show (s) {
      // 打開時同步
      if (s) {
        this.tmpInput1 = this.defaultValue1
        this.tmpInput2 = this.defaultValue2
      }
    }
  },
  data () {
    return {
      tmpInput1: '',
      tmpInput2: ''
    }
  },
  computed: {
    screen () {
      const { height, width } = this.$store.state.screen
      return {
        height: height - 1,
        width
      }
    },
    wrapperRect () {
      const top = this.top == null ? 0 : this.top
      const left = this.left == null ? 0 : this.left
      const height = this.height == null ? 0 : this.height
      const width = this.width == null ? 0 : this.width
      return {
        top,
        left,
        height,
        width
      }
    },
    wrapperStyle () {
      const { top, left, height, width } = this.wrapperRect
      const { background } = this
      return {
        background,
        top: top + 'px',
        left: left + 'px',
        height: height + 'px',
        width: width + 'px'
      }
    }
  },
  methods: {
    clickBG (e) {
      console.log('this.cancellable', this.cancellable)
      if (this.cancellable) {
        this.close()
      }
    },
    submit () {
      const input1 = this.tmpInput1
      const input2 = this.tmpInput2
      this.$emit('submit', [
        input1,
        input2
      ])
      this.close()
    },
    close () {
      this.$emit('update:show', false)
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.fs-textinput{
  position: absolute;
  box-sizing: border-box;
  .fs-form{
    position: absolute;
    top: 5%;
    padding: 5% 5% 5% 5%;
    width: 100%;
  }
  .fs-textarea{
    resize: none;
    background-color: #DEDEDE;
    width: 100%;
    height: 135px;
    max-height: 30%;
    border-radius: 6px;
    padding: 8px;
  }
  ::placeholder {
    color: #817E7E;
  }
  .fs-form-control{
    text-align: center;
  }
  .fs-label{
    color: white;
    margin-top: 48px;
  }
  .fs-btn{
    display: inline-block;
    padding: 4px 35px 4px 35px;
  }
  .fs-btn-submit{
    background-color: #E57A7A;
    color: white;
    border-radius: 6px;
  }
}

</style>
